import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { getFormAnswersFromData } from '../../../../../../../utils/formAnswers';
import {
  ModalContent,
  SubTitle,
} from '../../styles';

import {
  Answer,
  Question,
  QuestionsContainer,
  QuestionsContainerWrapper,
} from './styles';
import texts from './texts.json';

const LeadDetails = ({ lead }) => {
  const formattedResponses = useMemo(() => getFormAnswersFromData(lead), [lead]);

  return (
    <ModalContent>
      <SubTitle>{texts.leadFormDetails}</SubTitle>
      <QuestionsContainerWrapper>
        <QuestionsContainer key="lead-id">
          <Question>{texts.leadId}</Question>
          <Answer>{lead.id}</Answer>
        </QuestionsContainer>
        {formattedResponses && formattedResponses.map(
          ({ question, answer }) => !!answer && (
            <QuestionsContainer key={question}>
              <Question>{question}</Question>
              <Answer>{answer}</Answer>
            </QuestionsContainer>
          ),
        )}
      </QuestionsContainerWrapper>
    </ModalContent>
  );
};

LeadDetails.propTypes = {
  lead: PropTypes.object.isRequired,
};

export default LeadDetails;
